import ajax from '@/modules/ajax';

export default class BoletoWatcher {
  constructor(options) {
    this.boletoLoading = $('[data-boleto-loading]');
    this.boletoStatus = $('[data-boleto-status]');
    this.options = options;
  }

  create() {
    if (this.boletoLoading.length) this.watch();
  }

  check() {
    ajax({ done: this.onCheck.bind(this), url: this.options.invoice_uri });
  }

  onCheck(json) {
    console.log(`[onCheck] ${json.payment_method} -> ${json.original_boleto_status}`);

    this.boletoStatus.text(json.boleto_status);

    if (json.original_boleto_status == 'boleto_registered') {
      this.boletoLoading.remove();
      this.boletoStatus.removeClass('bg-redy').addClass('bg-greeny');

      clearInterval(this.intervalCheck);
    }
  }

  watch() {
    this.intervalCheck = setInterval(this.check.bind(this), 3000);
  }
}
